// src/components/ArticleModal.jsx
import React, { useEffect } from 'react';

function ArticleModal({ article, onClose }) {
  // Disable background scrolling while the modal is open.
  useEffect(() => {
    const originalOverflow = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  // Prevent touch events from propagating to the underlying view.
  const stopPropagation = (e) => e.stopPropagation();

  if (!article) return null;

  const content = article.deepdive || "No detailed content available.";

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40 p-4"
      onTouchStart={stopPropagation}
      onTouchMove={stopPropagation}
      onTouchEnd={stopPropagation}
    >
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* Fixed Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-50 text-gray-600 hover:text-gray-800 text-3xl"
          aria-label="Close"
        >
          &times;
        </button>
        {/* Scrollable Content Container */}
        <div className="flex-1 min-h-0 overflow-y-auto px-6 py-6">
          {article.top_image && (
            <img
              src={article.top_image}
              alt={article.title}
              className="w-full h-64 object-cover rounded-xl mb-6"
            />
          )}
          <h2 className="text-4xl font-light tracking-tight mb-4">{article.title}</h2>
          {article.authors && article.authors.length > 0 && (
            <p className="text-sm text-gray-500 mb-2">
              By {article.authors.join(', ')}
            </p>
          )}
          {article.publish_date && (
            <p className="text-sm text-gray-500 mb-6">
              {new Date(article.publish_date).toLocaleDateString()}
            </p>
          )}
          <div className="text-lg text-gray-700 whitespace-pre-wrap">
            {content}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ArticleModal;
